
import PropTypes from 'prop-types';
import Link from 'next/link'
import styles from './Pagination.module.css';

const Pagination = ({ isFirstPage, isLastPage, basePageLink, currentPageNumber, lastPageNumber, getLinkHref, paginationText, pageSize }) => {
  const renderFirstPageArrow = () => {
    if (!isFirstPage) {
      return (
        <li>
          <Link href={`${basePageLink}1`}>
            1
          </Link>
        </li>
      );
    } else {
      return (
        <li className={styles.currentPage}>
          1
        </li>
      )
    }
  }

  const renderLastPageArrow = () => {
    if (!isLastPage) {
      return (
        <li>
          <Link href={`${basePageLink}${lastPageNumber}`}>
            {lastPageNumber}
          </Link>
        </li>
      );
    } else {
      return (
        <li className={styles.currentPage}>{lastPageNumber}</li>
      )
    }
  }

  const renderPageLinks = () => {
    let pageIndexes = [-2, -1, 0, 1, 2];
    // give more options for first and last few pages
    if (isLastPage || currentPageNumber + 1 == lastPageNumber || currentPageNumber + 2 == lastPageNumber) {
      pageIndexes.unshift(-3, -4)
    } else if (isFirstPage || currentPageNumber - 1 == 1 || currentPageNumber - 2 == 1) {
      pageIndexes.push(3, 4)
    }

    return pageIndexes.map((pageIndex, index) => {
      if (currentPageNumber + pageIndex > 1 && currentPageNumber + pageIndex < lastPageNumber) {

        if (pageIndex + currentPageNumber == currentPageNumber) {
          return (
            <li key={index} className={styles.currentPage}>{currentPageNumber}</li>
          )
        } else {
          // visual for when more than one page is between first/last pages
          return (
            <li className="pageNumber" key={index}>
              {pageIndex == pageIndexes[0] && currentPageNumber + pageIndex - 1 != 1 ? <span className={styles.firstDots}> ... </span> : null}
              <Link href={`${basePageLink}${currentPageNumber + pageIndex}`}>
                {currentPageNumber + pageIndex}
              </Link>
              {pageIndex == pageIndexes[pageIndexes.length - 1] && currentPageNumber + pageIndex + 1 != lastPageNumber ? <span className={styles.lastDots}> ... </span> : null}
            </li>
          );
        }

      }
    });
  }

  if (lastPageNumber > 1) {
    return (
      <div className={lastPageNumber > 999 ? `${styles.pagination} ${styles.fullwidth}` : `${styles.pagination}`}>
        <div className={`${paginationText ? styles.paginationWithText : styles.paginationWithoutText}`} >{paginationText} </div>
        <div>
          <ul>
            {!isFirstPage ? // previous page button
              <li>
                <Link href={`${basePageLink}${currentPageNumber - 1}`}>
                  {"<"}
                </Link>
              </li> : null
            }
            {renderFirstPageArrow()}
            {renderPageLinks()}
            {renderLastPageArrow()}
            {!isLastPage ? //next page button
              <li>
                <Link href={`${basePageLink}${currentPageNumber + 1}`}>
                  {">"}
                </Link>
              </li> : null
            }
          </ul>
        </div>
      </div>
    );
  } else return null
}

Pagination.propTypes = {
  currentPageNumber: PropTypes.number,
  lastPageNumber: PropTypes.number,
  basePageLink: PropTypes.string,
  isFirstPage: PropTypes.bool,
  isLastPage: PropTypes.bool
}

export default Pagination;